'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('./button');

var _button2 = _interopRequireDefault(_button);

var _ExternalServiceTypes = require('../constants/ExternalServiceTypes');

var _ExternalServiceTypes2 = _interopRequireDefault(_ExternalServiceTypes);

var _logger = require('common/logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ExternalServiceUpdateURL = '/account/updateExternalService';
var MyAccountIntegrationsHomeURL = '/home/myAccount?current_tab=integrations';

var IntegrationActivationButton = _react2['default'].createClass({
    displayName: 'IntegrationActivationButton',


    propTypes: {
        'isActive': _react2['default'].PropTypes.bool.isRequired,
        'serviceTypeCode': _react2['default'].PropTypes.string,
        'buttonLink': _react2['default'].PropTypes.string
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'buttonLink': '#'
        };
    },


    // Original logic moved from myAccount.php
    clickHandler: function clickHandler(event) {
        event.stopPropagation();
        event.preventDefault();

        var el = $(event.target).closest('div');
        var isActivated = el.hasClass('is-activated');
        var textContainer = $('button .l-nowrap > span', el);
        var text = $.trim(textContainer.text());
        var servTypeCode = $(' > a button', el).attr('rel');

        var postData = {
            'service_type': servTypeCode,
            'is_deactivate': isActivated ? '1' : '0',
            'csrf_token': $('#update_ext_serv_csrf_token').val()
        };

        // If activating Google Drive
        if (!isActivated && servTypeCode == _ExternalServiceTypes2['default'].GOOGLE_DRIVE) {
            if ($.browser.msie && parseInt($.browser.version, 10) < 8) {
                $.fancybox('<div class="browser_warning"><strong>This option requires a more up to date browser</strong><p>Download the latest <a href="http://windows.microsoft.com/en-US/internet-explorer/downloads/ie" target="_blank" rel="noopener noreferrer">Microsoft Internet Explorer</a> or <a href="http://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">Google Chrome</a></p></div>', { 'padding': 20 });
                return;
            }
        }

        var showAsBusy = function showAsBusy(isBusy) {
            textContainer.html(isBusy ? 'Activating...' : text);
        };

        showAsBusy(true);

        $.ajax({
            'dataType': 'json',
            'type': 'POST',
            'url': ExternalServiceUpdateURL,
            'data': postData,
            success: function success(data) {

                var integration;
                for (var key in _ExternalServiceTypes2['default']) {
                    if (_ExternalServiceTypes2['default'][key] === postData.service_type) {
                        integration = key;
                    }
                }
                var eventType = postData.is_deactivate == 0 ? 'activate' : 'deactivate';
                _logger2['default'].track('IntegrationActivationButton._' + eventType, {
                    integration: integration
                });

                showAsBusy(false);
                if (data.auth_url) {
                    window.location = data.auth_url.replace(/&amp;/g, '&'); // FIXME: Needed because it gets returned HTML-encoded
                } else {
                    window.location = MyAccountIntegrationsHomeURL;
                }
            },
            error: function error() {
                showAsBusy(false);
                alert('An error occurred, try again or contact support at support@hellosign.com'); // FIXME - get email address dynamically, and localize text (DB)
            }
        });
    },
    render: function render() {
        var hasCustomButtonLink = this.props.buttonLink !== '#';
        var btn = _react2['default'].createElement(_button2['default'], { buttonText: this.props.isActive ? 'Deactivate' : 'Activate',
            buttonLink: hasCustomButtonLink ? this.props.buttonLink : void 0,
            buttonClass: 'border-1-grasshopper',
            buttonColor: this.props.isActive ? 'grasshopper' : 'white',
            buttonTextColor: this.props.isActive ? 'white' : 'grasshopper',
            buttonHoverTextColor: 'white',
            buttonHoverColor: 'grasshopper',
            openInNewWindow: true,
            buttonAttrs: this.props.serviceTypeCode ? { 'rel': this.props.serviceTypeCode } : null,
            buttonLinkUsePost: false,
            onClick: hasCustomButtonLink ? void 0 : this.clickHandler
        });

        return btn;
    }
});

module.exports = IntegrationActivationButton;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/integration-activation-button.jsx
 ** module id = 722
 ** module chunks = 0
 **/